import { formatDate } from 'utils/FormatDate'

/* Devuelve un objeto de filtros para Yii. */
export function formatYiiFilters(values, filterOptions) {
    const allowEmpty = filterOptions.allowEmpty ?? false
    const filters = {}
    for (const key in values) {
        const value = values[key]
        if (value === undefined || value === null) continue
        if (allowEmpty || value !== '') {
            if ((filterOptions.equal || []).includes(key)) {
                filters[key] = value
            } else if ((filterOptions.contain || []).includes(key)) {
                filters[key] = { ilike: value }
            } else if ((filterOptions.start || []).includes(key)) {
                filters[key] = { istart: value }
            } else if ((filterOptions.end || []).includes(key)) {
                filters[key] = { iend: value }
            } else if ((filterOptions.gt || []).includes(key)) {
                filters[key] = { '>': value }
            } else if ((filterOptions.lt || []).includes(key)) {
                filters[key] = { '<': value }
            } else if ((filterOptions.in || []).includes(key)) {
                filters[key] = { in: value }
            } else if ((filterOptions.nin || []).includes(key)) {
                filters[key] = { nin: value }
            } else if ((filterOptions.is || []).includes(key)) {
                filters[key] = { is: value }
            } else if ((filterOptions.isnt || []).includes(key)) {
                filters[key] = { isnt: value }
            } else if ((filterOptions.betweenDate || []).includes(key)) {
                if (Array.isArray(value) && value.length > 0) {
                    const dateIni = formatDate(value[0], 'Y-m-d')
                    const dateEnd = value.length > 1 ? formatDate(value[1], 'Y-m-d') : dateIni
                    if (dateIni && dateEnd) {
                        filters[key] = { '>': `${dateIni} 00:00:00`, '<': `${dateEnd} 23:59:59` }
                    }
                }
            } else if ((filterOptions.between || []).includes(key)) {
                if (Array.isArray(value) && value.length === 2) {
                    filters[key] = { '>': value[0], '<': value[1] }
                }
            } else if ((filterOptions.null || []).includes(key)) {
                if (value === true) {
                    filters[key] = { is: 'NULL' }
                } else if (value === false) {
                    filters[key] = { isnt: 'NULL' }
                }
            } else if ((filterOptions.bool || []).includes(key)) {
                if (typeof value === 'boolean') {
                    filters[key] = value ? 1 : 0
                }
            }
        }
    }
    return filters
}
